const serviceWorkerActionTypes = {
  INITIALIZE_SERVICE_WORKER: 'INITIALIZE_SERVICE_WORKER',
  UPDATE_SERVICE_WORKER: 'UPDATE_SERVICE_WORKER',
};

export default serviceWorkerActionTypes;
